// extracted by mini-css-extract-plugin
module.exports = {"tip":"tip___yuVzU","tipIcon":"tipIcon___3PEpn","arrow":"arrow___4e-xl","title":"title___1hN-g","hidden":"hidden___2fBTO","h5":"h5___1qsb1"};